const PROXY_HOSTS = new Set([
  "wheel-trader.us",
  "www.wheel-trader.us",
  "172.239.64.187",
  "172-239-64-187.sslip.io",
]);

export function isProxyUrl(url: string): boolean {
  try {
    return PROXY_HOSTS.has(new URL(url).hostname);
  } catch {
    return false;
  }
}

/** Ensure Accept/Content-Type on same-origin proxy data / API fetch calls. */
export function installProxyAuthShim(): void {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const url =
      typeof input === "string"
        ? input
        : input instanceof URL
          ? input.toString()
          : input.url;
    let attachHeaders = false;
    try {
      const parsed = new URL(url, window.location.origin);
      attachHeaders =
        parsed.origin === window.location.origin &&
        (parsed.pathname.startsWith("/api") ||
          parsed.pathname.startsWith("/own-capital") ||
          parsed.pathname.startsWith("/margin-cost-history") ||
          parsed.pathname.startsWith("/tax-settings") ||
          parsed.pathname.startsWith("/tax/due") ||
          parsed.pathname.startsWith("/sf-credentials") ||
          parsed.pathname.startsWith("/tenant/") ||
          parsed.pathname.startsWith("/mobile-ui-preferences") ||
          parsed.pathname.startsWith("/marketdata") ||
          parsed.pathname.startsWith("/market-risk") ||
          parsed.pathname.startsWith("/astrology/") ||
          parsed.pathname.startsWith("/analytics/") ||
          parsed.pathname.startsWith("/agentic/") ||
          parsed.pathname.startsWith("/agents/") ||
          parsed.pathname.startsWith("/cache-") ||
          parsed.pathname.startsWith("/auth/"));
    } catch {
      attachHeaders = false;
    }
    if (!attachHeaders) return nativeFetch(input, init);

    const headers = new Headers(init?.headers);
    if (!headers.has("Accept")) headers.set("Accept", "application/json");
    if (init?.body != null && !headers.has("Content-Type")) {
      headers.set("Content-Type", "application/json");
    }
    return nativeFetch(input, {
      ...init,
      headers,
      credentials: init?.credentials ?? "include",
    });
  };
}

/** Fetch the Linode proxy (same-origin on web/mobile). */
export async function proxyFetch(url: string, init: RequestInit = {}): Promise<Response> {
  return fetch(url, init);
}
